import { AnyAction } from "redux";
import { createDialogReducer, DIALOG_DEFAULT_STATE } from "./dialog";
import { IDialogState } from "./index";
import {
  DELETE_CONFIRMATION_DIALOG_NAME,
  getIAMEntityName,
} from "redux/actions/iam-entity";

export interface IIAMEntityState {
  [DELETE_CONFIRMATION_DIALOG_NAME]: IDialogState<string>;
}

function getIamDefaultState(): IIAMEntityState {
  return {
    [DELETE_CONFIRMATION_DIALOG_NAME]: DIALOG_DEFAULT_STATE,
  };
}

const getDeleteConfirmationReducer = () =>
  createDialogReducer(getIAMEntityName(), DELETE_CONFIRMATION_DIALOG_NAME);

export function iamEntity(
  state: IIAMEntityState = getIamDefaultState(),
  action: AnyAction
): IIAMEntityState {
  state = getDeleteConfirmationReducer()(state, action);
  return state;
}
